if (!customElements.get('nq-behind-art')) {
  class NqBehindArt extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mode = this.dataset.playMode || 'inline';
      this.dialog = this.querySelector('.nq-bta__dialog');
      this.frame = this.querySelector('.nq-bta__dialog-frame');

      if (this.dataset.observe === 'true' && !this.reducedMotion && 'IntersectionObserver' in window) {
        this.classList.add('is-animated');
        this.revealObserver = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-visible');
            this.revealObserver.disconnect();
          },
          { threshold: 0.15 }
        );
        this.revealObserver.observe(this);
      }

      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);

      this.querySelectorAll('.nq-bta__video').forEach((video) => {
        video.addEventListener('pause', () => this.handleStop(video));
        video.addEventListener('ended', () => this.handleStop(video, true));
      });

      if (this.dataset.preview === 'true' && !this.reducedMotion && 'IntersectionObserver' in window) {
        this.previewObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const card = entry.target;
              const video = card.querySelector('.nq-bta__video');
              if (!video || card.classList.contains('is-playing')) return;
              if (entry.isIntersecting) {
                this.startPreview(card, video);
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.4 }
        );
        this.querySelectorAll('.nq-bta__card[data-video]').forEach((card) => this.previewObserver.observe(card));
      }

      if (this.dialog) {
        this.dialog.addEventListener('close', () => {
          if (this.frame) this.frame.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.remove();
          });
        });
      }

      if (window.Shopify && window.Shopify.designMode) {
        this.onSectionSelect = (event) => {
          if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;
          if (!this.classList.contains('is-animated')) return;
          this.classList.remove('is-visible');
          void this.offsetWidth;
          requestAnimationFrame(() => this.classList.add('is-visible'));
        };
        document.addEventListener('shopify:section:select', this.onSectionSelect);
      }
    }

    handleClick(event) {
      if (event.target.closest('[data-bta-close]') || (this.dialog && event.target === this.dialog)) {
        this.dialog.close();
        return;
      }

      const play = event.target.closest('.nq-bta__play');
      if (!play || !this.contains(play)) return;
      const card = play.closest('.nq-bta__card');
      const video = card && card.querySelector('.nq-bta__video');
      if (!video) return;

      event.preventDefault();
      if (this.mode === 'popup' && this.dialog && typeof this.dialog.showModal === 'function') {
        this.openPopup(video);
      } else {
        this.playInline(card, video);
      }
    }

    startPreview(card, video) {
      video.muted = true;
      video.loop = true;
      video.preload = 'auto';
      const attempt = video.play();
      if (attempt && attempt.then) {
        attempt.then(() => card.classList.add('is-previewing')).catch(() => {});
      } else {
        card.classList.add('is-previewing');
      }
    }

    pauseOthers(current) {
      this.querySelectorAll('.nq-bta__card.is-playing .nq-bta__video').forEach((video) => {
        if (video !== current) video.pause();
      });
    }

    playInline(card, video) {
      this.pauseOthers(video);
      card.classList.remove('is-previewing');
      card.classList.add('is-playing');
      video.loop = false;
      video.muted = false;
      video.controls = true;
      video.preload = 'auto';
      if (this.dataset.preview === 'true') video.currentTime = 0;
      const attempt = video.play();
      if (attempt && attempt.catch) attempt.catch(() => this.handleStop(video));
    }

    openPopup(video) {
      this.pauseOthers(null);
      const clone = video.cloneNode(true);
      clone.className = '';
      clone.muted = false;
      clone.loop = false;
      clone.controls = true;
      clone.autoplay = true;
      clone.preload = 'auto';
      clone.playsInline = true;
      this.frame.querySelectorAll('video').forEach((old) => old.remove());
      this.frame.appendChild(clone);
      this.dialog.showModal();
      const attempt = clone.play();
      if (attempt && attempt.catch) attempt.catch(() => {});
    }

    handleStop(video, ended) {
      const card = video.closest('.nq-bta__card');
      if (!card || !card.classList.contains('is-playing')) return;
      if (!ended && !video.paused) return;
      card.classList.remove('is-playing');
      video.controls = false;

      if (this.dataset.preview === 'true' && !this.reducedMotion) {
        this.startPreview(card, video);
      } else if (ended) {
        video.currentTime = 0;
      }
    }

    disconnectedCallback() {
      if (this.revealObserver) this.revealObserver.disconnect();
      if (this.previewObserver) this.previewObserver.disconnect();
      if (this.onClick) this.removeEventListener('click', this.onClick);
      if (this.onSectionSelect) document.removeEventListener('shopify:section:select', this.onSectionSelect);
    }
  }

  customElements.define('nq-behind-art', NqBehindArt);
}
